module.exports = __webpack_public_path__ + "img/16l004-15.1a8cf28f.jpg";